import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import authService from '../services/AuthService';

const AuthCallback: React.FC = () => {
  useEffect(() => {
    const handleCallback = async () => {
      try {
        await authService.completeAuthentication();
        const redirectUri = localStorage.getItem('redirectUri') || '/';
        localStorage.removeItem('redirectUri');
        window.location.href = redirectUri;
      } catch (error) {
        console.error('Authentifizierung fehlgeschlagen:', error);
        window.location.href = '/';
      }
    };

    handleCallback();
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        Anmeldung wird verarbeitet...
      </Typography>
    </Box>
  );
};

export default AuthCallback;
